import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=8e6aa658&scoped=true&"
var script = {}
import style0 from "./dashboard.vue?vue&type=style&index=0&id=8e6aa658&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6aa658",
  null
  
)

export default component.exports